import { useCallback, useMemo, useRef } from 'react';

import { DIALOG_AUTO_FOCUS_SELECTOR } from '../constants/dialog-auto-focus.constant';

// A dialog or drawer mounted already open (or opened over another one) gets its paper
// focused by MUI's focus traps, which ignore autoFocus; the element marked with
// DIALOG_AUTO_FOCUS_ATTRIBUTE is focused once the opening transition ends.
export const useDialogAutoFocus = () => {
  const paperRef = useRef<HTMLDivElement>(null);

  const handleEntered = useCallback(() => {
    paperRef.current
      ?.querySelector<HTMLElement>(DIALOG_AUTO_FOCUS_SELECTOR)
      ?.focus();
  }, []);

  return useMemo(
    () => ({
      paper: { ref: paperRef },
      transition: { onEntered: handleEntered },
    }),
    [handleEntered],
  );
};
